import {
    GET_ALL_LESSONS_REQUEST,
    GET_ALL_LESSONS_SUCCESS,
    GET_ALL_LESSONS_FAILURE,
} from '../actions';


const initialState = {};

const LessonsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_LESSONS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_ALL_LESSONS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_ALL_LESSONS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default LessonsReducer;